import * as React from "react";
import { Show, SimpleShowLayout, TextField, RichTextField, ImageField } from 'react-admin';
const MerchantIntentTesterLablesDetail = ({ ...props }) => (

    <Show title="Labels" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="title" label="Title" />
            <TextField source="product_url" label="Product URL" />
            <TextField source="radio_label1" label="Label 1" />
            <TextField source="radio_label2" label="Label 2" />
            <TextField source="text_field_value" label="Text Input" />
            <TextField source="text_field_title" label="Text Input Title" />
        </SimpleShowLayout>
    </Show>
);
export default MerchantIntentTesterLablesDetail